import React from 'react'
import { CommonButton, CommonButtonProps } from './common-button'
import { ButtonTypeEnum, ButtonSizeEnum } from './enums'

export interface IconButtonWithTypeProps
  extends Omit<
    CommonButtonProps,
    'type' | 'iconBefore' | 'iconAfter' | 'children'
  > {}

export const PrimaryIconButton = ({ ...props }: IconButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Primary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const SecondaryIconButton = ({ ...props }: IconButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Secondary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const TertiaryIconButton = ({ ...props }: IconButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Tertiary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const GhostIconButton = ({ ...props }: IconButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Ghost}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const GrayIconButton = ({ ...props }: IconButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Gray}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)
